import styled from 'styled-components';
import { ArrowDirectionButton } from '../../../../components/inputs/buttons/ArrowDirectionButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xxl};
  background: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS */
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;

export const ArrowRadioGroup = styled(ArrowDirectionButton)``;
